import React from 'react';
import OptionsList from '../../Components/OptionsList/OptionsList';
import BaseOptionsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList';
import * as configuratorActions from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import Option from '../../Components/Option/Option';
import { deselectMultipleOptions, setCustomColor, setCustomData } from '../../Reducers/Configurator/Actions';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';

const CustomOptionsListContainer = (props) => {
  const { selectedProductPart } = useSelector((state) => state.menu);
  const {
    selectedoptionclassification,
    options,
    filteredOptionclassifications,
    configuration: {
      customdata: { selectedSubOptions },
    },
  } = useSelector((state) => state.configurator);
  const dispatch = useDispatch();
  const groupedComponents = get(selectedProductPart, 'components', []);
  const childOptions = options.filter((op) =>
    op.attributes.find((attr) => attr.identifier === 'is_child_option_of')
  );
  const parentOptions = options.filter(
    (op) =>
      (op.attributes && op.attributes.length === 0) ||
      op.attributes.find((attr) => attr.identifier !== 'is_child_option_of')
  );
  const selectedComponentCustomData = selectedSubOptions
    ? selectedSubOptions.filter(
        (o) =>
          selectedoptionclassification &&
          o.optionclassificationIdentifier === selectedoptionclassification.identifier
      )
    : [];
  let groupedOptions = parentOptions;
  if (childOptions.length > 0) {
    groupedOptions = parentOptions.map((po) => {
      const subOptions = childOptions.filter((op) =>
        op.attributes
          .find((attr) => attr.identifier === 'is_child_option_of')
          .values.find((val) => val.value === po.identifier)
      );
      return {
        ...po,
        subOptions: subOptions.length > 0 ? [{ ...po, title: t('standard') }, ...subOptions] : [],
        selectedSubOption: get(
          selectedComponentCustomData.find((cd) => cd.optionIdentifier === po.identifier),
          'subOption'
        ),
      };
    });
  }

  const selectedParentOptions = selectedComponentCustomData.map((so) => so.optionIdentifier);
  return (
    <BaseOptionsListContainer
      {...props}
      Component={OptionsList}
      OptionComponent={Option}
      groupedComponents={groupedComponents}
      selectedParentOptionsIdentifier={selectedParentOptions}
      options={groupedOptions}
      selectedComponent={selectedoptionclassification}
      selectedProductPart={selectedProductPart}
      deselectMultipleOptions={(optionsList) => dispatch(deselectMultipleOptions(optionsList))}
      selectComponent={(optionClassificationIdentifier) => {
        const optionClassification = filteredOptionclassifications.find(
          (oc) => oc.identifier === optionClassificationIdentifier
        );
        dispatch(configuratorActions.selectOptionclassification(optionClassification, true, true));
      }}
      saveSubOptionMappingToCustomData={(subOptionMap) => dispatch(setCustomData(subOptionMap))}
      saveChosenColor={(customData) => dispatch(setCustomColor(customData))}
    />
  );
};

export default CustomOptionsListContainer;
